export const DELETE_PRODUCT_FROM_FAVORITES = 'DELETE_PRODUCT_FROM_FAVORITES';

export const deleteProductFromFavorites = (id) => {
  return {
    type: DELETE_PRODUCT_FROM_FAVORITES,
    payload: id,
  };
};
